// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"7227a138","257":"93f09ef6"}[chunkId] + ".chunk.js";
};